<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import Banner from "@/Components/Banner.vue";

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import MediationFirst from "@/Components/MediationFirst.vue";
import MediationSecond from "@/Components/MediationSecond.vue";
import MediationThird from "@/Components/MediationThird.vue";
import MediationFourth from "@/Components/MediationFourth.vue";
import MediationFifth from "@/Components/MediationFifth.vue";
import MediationSix from "@/Components/MediationSix.vue";
import MediationSeven from "@/Components/MediationSeven.vue";
import MediationEight from "@/Components/MediationEight.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <MediationFirst />
    <MediationSecond />
    <MediationThird />
    <MediationFourth />
    <MediationFifth />
    <MediationSix />
    <MediationSeven />
    <MediationEight />
  </PublicLayout>
</template>
